import { IPropertyForm } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";

const prepareAlterEstateToServer = (body: IPropertyForm) => {
  if (!body.is_edit) {
    return {
      is_alterestate_published: null,
      can_alterestate_sync: null,
      alterestate_commission: null
    };
  }
  const state: any = {};
  if (body.want_publish_on_alterestate) {
    state["can_alterestate_sync"] = 1;
  }
  if (body.want_publish_on_internal_alterestate) {
    state["is_alterestate_published"] = 1;
  }
  if (
    body.garante_commission_alterestate &&
    body.want_publish_on_internal_alterestate
  ) {
    state["alterestate_commission"] = String(body.garante_commission_alterestate);
  }
  return state;
};

export default prepareAlterEstateToServer;
